// Get the modal
var modal = document.getElementById("jsModal");

// Get the button that opens the modal
var btn = document.getElementById("openBox");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("js-close")[0];

// Get the Textfield
var personalName = document.getElementsByClassName("engraveTextInput")[0];

var popupImgWidth;
 
// Get the announcement bar header , then hide we $popupImage
var announcement = document.getElementById("shopify-section-announcement");
var header = document.getElementById("shopify-section-header");

// When the user clicks the button, open the modal
btn.onclick = function() {
  document.documentElement.classList.add("popupOpen");
  document.body.classList.add("popupOpen");
  modal.style.display = "block";
  if ($(window).width() < 767 ) {
    announcement.style.display = "none";
    header.style.display = "none";
  }
  showEngravingOnOpen();
}

// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  document.documentElement.classList.remove("popupOpen");
  document.body.classList.remove("popupOpen");
  modal.style.display = "none";
  announcement.style.display = "block";
  header.style.display = "block";
}

// When the user clicks anywhere outside of the modal, close it
// window.onclick = function(event) {
//   if (event.target == modal) {
//     modal.style.display = "none";
//   }
// }

showEngravingOnOpen = () =>{
  var $engraveText = localStorage.getItem("engraveText");
  var $textOverlayOut = $('.overlay-text-out');

  if ($engraveText != '') {
    $textOverlayOut.text($engraveText);
  }
  popupImgWidth = $('#jsModal .left-col').width();
}

closePop = () =>{
  color = '';
  document.documentElement.classList.remove("popupOpen");
  document.body.classList.remove("popupOpen");
  $('#jsModal').css('display','none');
  $('#shopify-section-announcement').css('display','block');
  $('#shopify-section-header').css('display','block');
  color = $('.js-modal .overlay-text').css("color");
  console.log('color: '+ color)
  $('.popup-text-overlay').attr('data-ptext-ratio', ($(window).width() / 2 / popupImgWidth) )
  $('.popup-text-overlay').attr('data-ptext-bg', popupImgWidth )
  $('.popup-text-overlay > .overlay-text-out').css('transform', 'scale('+$(window).width() / 2 / popupImgWidth+')')
  $('.popup-text-overlay > .overlay-text-out').css('color', color)
}
// onInputTypeB = (dom) => {
//  dom.value = dom.value.replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '');
// }